module.exports = __webpack_public_path__ + "img/full7-min.0d229cf0.png";